import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { IErrorHandling, OnboardingFormFields } from '@Types/index';

export const PersonalErrorMap = {
  INVALID_FIRST_NAME: 4047,
  INVALID_LAST_NAME: 4048,
  INCORRECT_AGE: 4078,
  MUST_BE_OLDER_THAN: 4028,
  NAME_TOO_LONG: 4094,
  EXPIRATION_MUST_BE_FUTURE: 4031,
};

export const PersonalErrorsObjectMap = new Map<number, IErrorHandling>([
  [
    PersonalErrorMap.INVALID_FIRST_NAME,
    {
      errorCode: PersonalErrorMap.INVALID_FIRST_NAME,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.FIRST_NAME,
      callBack: () => {},
    },
  ],
  [
    PersonalErrorMap.INVALID_LAST_NAME,
    {
      errorCode: PersonalErrorMap.INVALID_LAST_NAME,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.LAST_NAME,
      callBack: () => {},
    },
  ],
  [
    PersonalErrorMap.INCORRECT_AGE,
    {
      errorCode: PersonalErrorMap.INCORRECT_AGE,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.DATE_OF_BIRTH,
      callBack: () => {},
    },
  ],
  [
    PersonalErrorMap.MUST_BE_OLDER_THAN,
    {
      errorCode: PersonalErrorMap.MUST_BE_OLDER_THAN,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.DATE_OF_BIRTH,
      callBack: () => {},
    },
  ],
  [
    PersonalErrorMap.NAME_TOO_LONG,
    {
      errorCode: PersonalErrorMap.NAME_TOO_LONG,
      redirectPath: routesModel[RoutesMap.DEBIT_CARD_NAME].path,
      relatedFieldName: OnboardingFormFields.FIRST_NAME,
      callBack: () => {},
    },
  ],
  [
    PersonalErrorMap.EXPIRATION_MUST_BE_FUTURE,
    {
      errorCode: PersonalErrorMap.EXPIRATION_MUST_BE_FUTURE,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.DATE_OF_BIRTH,
      callBack: () => {},
    },
  ],
]);
